export const SITE_NAME = 'NetHyTech';
export const PRODUCT_NAME = 'Jarvis AI';
export const DEFAULT_DESCRIPTION = 'Jarvis AI Assistant by NetHyTech helps developers, creators, and operators automate workflows, build with AI, and scale productivity with memory, voice, and intelligent tooling.';
export const DEFAULT_OG_IMAGE = '/logo.jpg';

const FALLBACK_SITE_URL = 'https://nethytech.online';

export const getSiteUrl = () => {
    const envSiteUrl = process.env.REACT_APP_SITE_URL;

    if (envSiteUrl) {
        return envSiteUrl.replace(/\/+$/, '');
    }

    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin.replace(/\/+$/, '');
    }

    return FALLBACK_SITE_URL;
};

export const toAbsoluteUrl = (path = '/') => {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }

    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return new URL(normalizedPath, getSiteUrl()).toString();
};

export const buildPageTitle = (title) => {
    if (!title) {
        return `${PRODUCT_NAME} Assistant | ${SITE_NAME}`;
    }

    return `${title} | ${SITE_NAME}`;
};

export const FOUNDER_NAME = 'Anubhav Chaturvedi';

export const SOCIAL_PROFILES = [
    'https://www.youtube.com/@NetHyTech',
    'https://x.com/NetHyTech',
    'https://www.instagram.com/anubhavchaturvedi__/',
    'https://github.com/AnubhavChaturvedi-GitHub'
];

export const KNOWS_ABOUT = [
    'Jarvis AI',
    'AI assistants',
    'AI products',
    'AI automation',
    'AI courses and tutorials',
    'Python automation',
    'voice assistants',
    'machine learning',
    'web development'
];

export const buildFounderSchema = (overrides = {}) => ({
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': toAbsoluteUrl('/#founder'),
    name: FOUNDER_NAME,
    alternateName: 'NetHyTech',
    url: toAbsoluteUrl('/about'),
    jobTitle: 'Founder of NetHyTech, AI Developer and Educator',
    description: `${FOUNDER_NAME} is the founder of NetHyTech, creator of the Jarvis AI assistant, and an AI educator publishing tutorials, courses, and open-source AI projects.`,
    sameAs: SOCIAL_PROFILES,
    knowsAbout: KNOWS_ABOUT,
    worksFor: { '@id': toAbsoluteUrl('/#organization') },
    ...overrides
});

export const buildOrganizationSchema = (overrides = {}) => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': toAbsoluteUrl('/#organization'),
    name: SITE_NAME,
    alternateName: 'NetHyTech AI',
    url: toAbsoluteUrl('/'),
    logo: toAbsoluteUrl('/logo-circle.png'),
    description: 'NetHyTech is an AI company by Anubhav Chaturvedi building the Jarvis AI assistant, AI products, source code, courses, tutorials, and blogs on AI automation.',
    sameAs: SOCIAL_PROFILES,
    founder: { '@id': toAbsoluteUrl('/#founder') },
    knowsAbout: KNOWS_ABOUT,
    ...overrides
});

export const buildFaqSchema = (items) => ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer
        }
    }))
});

export const buildBreadcrumbSchema = (items) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: toAbsoluteUrl(item.path)
    }))
});
